module.exports = __webpack_public_path__ + "static/img/devices.9858892.svg";